enum DrmKeySystem {
    FAIRPLAY = 'com.apple.fps.1_0',
    PLAYREADY = 'com.microsoft.playready',
    WIDEVINE = 'com.widevine.alpha'
}

export default DrmKeySystem;